import api from './api';

export interface DashboardStats {
  ops_abertas: number;
  ops_em_producao: number;
  ops_concluidas: number;
  alertas_qualidade: number;
}

export interface OpsByStatusItem {
  status: string;
  total: number;
}

export interface TopProductItem {
  produto__codigo: string;
  produto__descricao: string;
  total: number;
}

export interface QualityAlertItem {
  lote__numero_lote: string | null;
  lote__produto__codigo: string | null;
  lote__produto__descricao: string | null;
  tipo: string;
  resultado: string;
  data_inspecao: string | null;
}

export interface CriticalStockItem {
  codigo: string;
  descricao: string;
  estoque_atual: number;
  estoque_minimo: number;
  unidade: string;
}

const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const response = await api.get<DashboardStats>('/industrializacao/dashboard/stats');
    return response.data;
  },
  async getOpsByStatus(): Promise<OpsByStatusItem[]> {
    const response = await api.get<OpsByStatusItem[]>('/industrializacao/dashboard/ops_by_status');
    return response.data;
  },
  async getTopProducts(limit = 10): Promise<TopProductItem[]> {
    const response = await api.get<TopProductItem[]>('/industrializacao/dashboard/top_products', {
      params: { limit },
    });
    return response.data;
  },
  async getQualityAlerts(): Promise<QualityAlertItem[]> {
    const response = await api.get<QualityAlertItem[]>('/industrializacao/dashboard/quality_alerts');
    return response.data;
  },
  async getCriticalStock(limit = 10): Promise<CriticalStockItem[]> {
    const response = await api.get<CriticalStockItem[]>('/industrializacao/dashboard/critical_stock', {
      params: { limit },
    });
    return response.data;
  },
};

export default dashboardService;
